import formBaseMixin from './form-base-mixin'
import {SHOW_HIDDEN_FIELDS} from '../../config/config.js'
import userFriendlyEr from "../../utils/userFriendlyEr";

export default {
  mixins: [formBaseMixin],
  data () {
    return {
      tabView: 'tab1',
      fields: {
        latitude: '',
        longitude: ''
      }
    }
  },
  computed: {
    showHiddenFields () {
      return SHOW_HIDDEN_FIELDS
    }
  },
  methods: {
    afterSave: async function () {
      let errors = []
      console.log(this.getEditablesEndpointsAndUrl())

      if (!this.$route.params.id) {
        let {postUrl, tmpEndpoints} = this.getEditablesEndpointsAndUrl()

        for (let i = 0; i < tmpEndpoints.length; i++) {
          if (this.$store.getters.readUrlEndpoint(tmpEndpoints[i])) {
            let data = this.$store.getters.readUrlEndpoint(tmpEndpoints[i]).data
            for (let j = 0; j < data.length; j++) {
              if (data[j]._isValid === true && data[j]._considerSaved === true) {
                // set sourceId
                // see src/app/waybill/components/task-table.vue addNewRowToTable
                data[j].sourceId = this.fields.id
                try {
                  await this.$store.dispatch('createModel', {
                    url: postUrl[i],
                    endpoint: tmpEndpoints[i],
                    data: data[j]
                  })
                } catch (e) {
                  console.log(e)
                  errors.push(userFriendlyEr.recognize(e))
                }
              } else {
                console.info('Invalid row')
                console.info(data[j])
              }
            }
          }
        }
      }

      if (errors.length > 0) {
        console.log(errors)
        return Promise.reject(errors.join('<br><br>'))
      }

      return Promise.resolve(1)
    },
    findNestedComponents (childrens = [], findCompName = 'e-form-group') {
      let founds = null
      let component = null
      for (let i = 0; i < childrens.length; i++) {
        component = childrens[i]
        let {name} = component.$options
        if (name && name === findCompName) {
          return childrens
        } else {
          let childs = component.$children || []
          let tmp = this.findNestedComponents(childs, findCompName)
          if (tmp !== null) {
            founds = tmp
          }
        }
      }
      return founds
    },
    grabOptionsDataFromFromGroup (group) {
      let f = {}
      if (group.inputType) {
        if (group.inputType === 'select') {
          // moved to: src/components/select/select.vue
          /* group.options.forEach(o => {
            if (o[group.optionValueKey] == group.model[group.name]) {
              f[`labelFor${group.name}`] = o[group.optionTextKey]
            }
          }) */
        }
      }
      return f
    },
    getSearchBody (fields) {
      let msg = ''
      for (let key in fields) {
        if (typeof fields[key] !== 'object' && !Array.isArray(fields[key])) {
          msg += ` ${fields[key]} `
        }
      }
      return msg
    },
    prepareFieldsForSend (fields = {}) {
      let groups = this.findNestedComponents(this.$children) || []
      // added label from options
      groups.forEach(group => {
        fields = Object.assign(
          fields,
          this.grabOptionsDataFromFromGroup(group)
        )
      })
      // genarate search body
      if (this.getSearchBody(fields)) {
        fields.searchBody = this.getSearchBody(fields)
      }
      return this.afterPrepareFieldsForSend(fields)
    },
    afterPrepareFieldsForSend (fields = {}) {
      return fields
    }
  }
}
